import { useEffect, useRef } from 'react';

// deps에 추가한 state가 변경될 때마다 callback이 실행
// 단, 최초 마운트 시에는 실행되지 않는다.
function useUpdateEffect<T>(callback: Function, deps: T[]) {
    const ref = useRef(false);

    useEffect(() => {
        if (ref.current) {
            callback();
        } else {
            ref.current = true;
        }
    }, [...deps]);
}

export default useUpdateEffect;
